export default __webpack_public_path__ + "static/media/1.ac98fb3c.png";